import { render, staticRenderFns } from "./OrgHomeInventory.vue?vue&type=template&id=7b71863f&scoped=true&"
import script from "./OrgHomeInventory.vue?vue&type=script&lang=js&"
export * from "./OrgHomeInventory.vue?vue&type=script&lang=js&"
import style0 from "./OrgHomeInventory.vue?vue&type=style&index=0&id=7b71863f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71863f",
  null
  
)

export default component.exports